import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../actions/SetDefinitions';
const initialState = {};
export const hastaTransmittersSlice = createSlice({
    name: 'hasta_transmitters',
    initialState,
    reducers: {
        hastaTransmittersCleared: () => {
            return {};
        },
        hastaTransmitterUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        hastaTransmitterDeleted: (state, action) => {
            delete state[action.payload];
        },
        hastaTransmittersReplaced: (state, action) => {
            const newState = {};
            for (const o of action.payload) {
                newState[o.id] = o;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (_, action) => {
            const newState = {};
            for (const o of action.payload.hasta_transmitters) {
                newState[o.id] = o;
            }
            return newState;
        });
    }
});
export const selectHastaTransmitters = (state) => state.definitions.hasta_transmitters;
export const selectHastaTransmitter = (id) => (state) => id == undefined ? undefined : state.definitions.hasta_transmitters[id];
export const { hastaTransmittersCleared, hastaTransmitterUpdated, hastaTransmitterDeleted, hastaTransmittersReplaced } = hastaTransmittersSlice.actions;
export const hastaTransmitterAdded = hastaTransmitterUpdated;
export default hastaTransmittersSlice.reducer;
